import { Modifier, EditorState, SelectionState } from 'draft-js'

const getWordAt = (string: string, position: number) => {
  // Perform type conversions
  const str = String(string)
  const pos = Number(position) >>> 0 // eslint-disable-line no-bitwise

  // Search for the word's beginning and end
  const left = str.slice(0, pos + 1).search(/\S+$/)
  const right = str.slice(pos).search(/\s/)

  // The last word in the string is a special case
  if (right < 0) {
    return {
      word: str.slice(left),
      begin: left,
      end: str.length,
    }
  }

  // Return the word, using the located bounds to extract it from the string
  return {
    word: str.slice(left, right + pos),
    begin: left,
    end: right + pos,
  }
}

const getSearchText = (editorState: EditorState, selection: SelectionState) => {
  const anchorKey = selection.getAnchorKey()
  const anchorOffset = selection.getAnchorOffset() - 1
  const currentContent = editorState.getCurrentContent()
  const currentBlock = currentContent.getBlockForKey(anchorKey)
  const blockText = currentBlock.getText()
  return getWordAt(blockText, anchorOffset)
}

export const addMention = (editorState: EditorState, { name, url }: { name: string; url: string }) => {
  const contentStateWithEntity = editorState.getCurrentContent().createEntity('LINK', 'IMMUTABLE', { name, url })
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey()

  const currentSelectionState = editorState.getSelection()
  const { begin, end } = getSearchText(editorState, currentSelectionState)

  // get selection of the @mention search text
  const mentionTextSelection = currentSelectionState.merge({
    anchorOffset: begin,
    focusOffset: end,
  }) as SelectionState // SMELL: some type weirdness here

  let mentionReplacedContent = Modifier.replaceText(
    editorState.getCurrentContent(),
    mentionTextSelection,
    `@${name}`,
    undefined,
    entityKey
  )

  // If the mention is inserted at the end, a space is appended right after for a smooth writing experience
  const blockKey = mentionTextSelection.getAnchorKey()
  const blockSize = editorState
    .getCurrentContent()
    .getBlockForKey(blockKey)
    .getLength()
  if (blockSize === end) {
    mentionReplacedContent = Modifier.insertText(
      mentionReplacedContent,
      mentionReplacedContent.getSelectionAfter(),
      ' '
    )
  }

  const newEditorState = EditorState.push(editorState, mentionReplacedContent, 'insert-fragment')
  return EditorState.forceSelection(newEditorState, mentionReplacedContent.getSelectionAfter())
}
